import { render, staticRenderFns } from "./RBC.vue?vue&type=template&id=18353c02&scoped=true&"
import script from "./RBC.vue?vue&type=script&lang=js&"
export * from "./RBC.vue?vue&type=script&lang=js&"
import style0 from "./RBC.vue?vue&type=style&index=0&id=18353c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18353c02",
  null
  
)

export default component.exports